module.exports = __webpack_public_path__ + "img/pr-4.ac2c1dd6.png";